import { gql } from '@apollo/client';

// Admin-only Ask Addy (Bedrock/Claude) usage & cost report. `groupBy` selects
// the breakdown dimension (user | model | promptType | day); the server returns
// overall totals plus per-group rows sorted by cost desc.
export const ASK_ADDY_USAGE_QUERY = gql`
  query AskAddyUsage(
    $from: String
    $to: String
    $userId: ID
    $groupBy: AskAddyUsageGroupBy
  ) {
    askAddyUsage(from: $from, to: $to, userId: $userId, groupBy: $groupBy) {
      from
      to
      groupBy
      totals {
        conversations
        generations
        chatMessages
        tokensIn
        tokensOut
        costUsd
        untrackedMessages
      }
      rows {
        key
        label
        generations
        chatMessages
        tokensIn
        tokensOut
        costUsd
        costSource
      }
    }
  }
`;
